<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<!-- Header: titolo + riga di stato della schermata, come le altre sezioni
     (dichiarazione, documenti, tabelle). -->
<div class="mt-3 ms-1 mb-3 w-100">
  <h3 class="m-0">Pianificazione fiscale</h3>
  <p class="m-0 text-muted">Tasse e contributi previsti, mese per mese.</p>
</div>

<div class="row g-2 d-flex align-items-stretch">
  <div class="col-md-4">
    <!-- Card "Cosa dovrai pagare?": superficie piatta bianca con bordo nero 2px
         e angolo basso-sinistra vivo (utility globali .custom-card-border /
         .izy-sharp-bl), icona del titolo chiusa nel riquadro bordato
         (.izy-corner-icon, come le card azione rapida in dashboard). -->
    <mat-card class="h-100 izy-sharp-bl custom-card-border izy-panel d-flex flex-column">
      <mat-card-content class="p-3 flex-grow-1 d-flex flex-column">
        <div class="izy-panel-heading">
          <span class="izy-corner-icon">
            <mat-icon fontSet="material-icons-outlined">payments</mat-icon>
          </span>
          <h5 class="izy-panel-title m-0">Cosa dovrai pagare?</h5>
        </div>
        <p class="izy-panel-subtitle">
          Per l'anno {{nextYear}}, secondo il simulatore, pagherai:
        </p>

        <div class="flex-grow-1 d-flex flex-column">
          <!-- Riquadri importo: due superfici in una sola tessera, la stessa
               distinzione delle card documento/evento. Fascia in alto lilla con
               l'etichetta e la freccia, fascia in basso bianca con l'importo in
               grande, separate dal tratto nero 2px. Sono <button> perche' sono
               a tutti gli effetti comandi (tastiera e screen reader inclusi):
               prima erano mat-card annidate, cliccabili solo col mouse. -->
          <button
            type="button"
            class="izy-amount-tile izy-sharp-bl custom-card-border"
            (click)="scrollToDettaglioMensile()"
          >
            <span class="izy-amount-tile-head">
              <span class="izy-amount-tile-label">
                <span class="izy-corner-icon izy-corner-icon--sm">
                  <mat-icon fontSet="material-icons-outlined">receipt_long</mat-icon>
                </span>
                Tasse
              </span>
              <span class="izy-goto-arrow">
                <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
              </span>
            </span>
            <span class="izy-amount-tile-value">
              {{nextYearTotalAmountTasse}}<span class="izy-amount-cur">&nbsp;€</span>
            </span>
          </button>

          <button
            type="button"
            class="mt-2 izy-amount-tile izy-sharp-bl custom-card-border"
            (click)="scrollToDettaglioMensile()"
          >
            <span class="izy-amount-tile-head">
              <span class="izy-amount-tile-label">
                <span class="izy-corner-icon izy-corner-icon--sm">
                  <mat-icon fontSet="material-icons-outlined">savings</mat-icon>
                </span>
                Contributi
              </span>
              <span class="izy-goto-arrow">
                <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
              </span>
            </span>
            <span class="izy-amount-tile-value">
              {{nextYearTotalAmountContributi}}<span class="izy-amount-cur">&nbsp;€</span>
            </span>
          </button>

          <div class="izy-divider-h izy-push-down mt-3 mb-2"></div>

          <!-- Metadati della posizione previdenziale: grigia dei metadati
               secondari con l'icona in petrol, come nelle card documento. -->
          <div class="izy-meta-row">
            <p class="izy-meta mb-0">
              <mat-icon class="izy-meta-icon me-1" fontSet="material-icons-outlined">account_balance</mat-icon>
              <span class="izy-meta-label me-1">Iscritto a:</span>
              <strong>{{ organization_data?.inps_fund_type }}</strong>
            </p>
            <button
              mat-icon-button
              class="izy-info-btn"
              (click)="openStatusInfoDialog()"
              matTooltip="Informazioni aggiuntive."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            </button>
          </div>

          <p class="izy-meta mb-0">
            <mat-icon class="izy-meta-icon me-1" fontSet="material-icons-outlined">percent</mat-icon>
            <span class="izy-meta-label me-1">Aliquota Imposta Sostitutiva:</span>
            {{ getTaxRate(organization_data?.type) }}
          </p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-md-8">
    <!-- Card del grafico: stessa superficie bianca bordata della card a
         fianco, cosi' la riga in cima alla pagina si legge come una coppia. -->
    <mat-card class="h-100 izy-sharp-bl custom-card-border izy-panel">
      <mat-card-content class="p-3">
        <div class="izy-panel-heading">
          <span class="izy-corner-icon">
            <mat-icon fontSet="material-icons-outlined">show_chart</mat-icon>
          </span>
          <h5 class="izy-panel-title m-0">Andamento tasse nei prossimi 2 anni</h5>
        </div>
        <p class="izy-panel-subtitle">Seleziona un anno in basso per iniziare</p>

        <div *ngIf="!isLoading" class="chart-container">
          <canvas baseChart
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  [type]="lineChartType">
          </canvas>
        </div>

        <div *ngIf="isLoading" class="spinner-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p class="mt-3 mb-0 text-muted">Caricamento grafico...</p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Header della seconda sezione, stessa impaginazione di quello in cima. -->
<div class="mt-4 ms-1 mb-3 w-100" #dettaglioMensile>
  <h4 class="m-0">Dettaglio mensile</h4>
  <p class="m-0 text-muted">Scadenze e importi dell'anno selezionato.</p>
</div>

<mat-card class="mb-3 izy-sharp-bl custom-card-border izy-panel">
  <mat-card-content class="p-3">
    <!-- Barra dei comandi: selettore anno nella pillola bordata nera
         (.custom-select-wrapper.year-select, come dashboard e tabelle) e una
         sola azione primaria in petrol (.izy-button-primary). -->
    <div class="izy-controls-row">
      <div class="izy-year-field">
        <span class="izy-field-label">Anno</span>
        <div class="custom-select-wrapper year-select">
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel"
              [(value)]="selectedYear"
              (selectionChange)="bothTaxableComputationAndYearChange()">
              <mat-option *ngFor="let year of availableYears" [value]="year">
                {{ year }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <button
        matButton="filled"
        class="izy-button-primary custom-button-border izy-add-event-btn"
        (click)="openNewFiscalEventDialog()"
      >
        <mat-icon>add</mat-icon>
        Carica eventi fiscali
      </button>
    </div>

    <div class="izy-divider-h mt-3 mb-1"></div>

    <!-- Riepilogo dell'anno: righe etichetta/valore separate dal tratto
         .izy-divider-h. Una sola versione responsive al posto delle due copie
         desktop/mobile: le righe passano in colonna sotto i 576px. -->
    <div class="izy-stat-list">
      <div class="izy-stat-row">
        <span class="izy-stat-label">
          <mat-icon class="izy-stat-icon me-1" fontSet="material-icons-outlined">request_quote</mat-icon>
          Fatturato incassato del {{selectedYear}}
          <button
            mat-icon-button
            class="izy-info-btn"
            (click)="handleAmountInfoClick($event)"
            matTooltip="Informazioni aggiuntive sul fatturato."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
          </button>
        </span>
        <span class="izy-stat-value">€ {{taxableAmount | number:'1.2-2'}}</span>
      </div>

      <div class="izy-divider-h"></div>

      <div class="izy-stat-row">
        <span class="izy-stat-label">
          <mat-icon class="izy-stat-icon me-1" fontSet="material-icons-outlined">percent</mat-icon>
          Incidenza tasse ({{selectedYear+1}})
        </span>
        <span class="izy-stat-value">{{formatIncidence(yearTaxIncidence)}}</span>
      </div>

      <div class="izy-divider-h"></div>

      <div class="izy-stat-row">
        <span class="izy-stat-label">
          <mat-icon class="izy-stat-icon me-1" fontSet="material-icons-outlined">percent</mat-icon>
          Incidenza contributi ({{selectedYear+1}})
        </span>
        <span class="izy-stat-value">{{formatIncidence(yearContributiIncidence)}}</span>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #amountInfoDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="izy-dialog-title d-flex align-items-center">
    <span class="izy-corner-icon me-2">
      <mat-icon fontSet="material-icons-outlined">info</mat-icon>
    </span>
    Dettagli Fatturato
  </h2>

  <mat-dialog-content class="pt-3">
    <p class="mb-2">
      Il <strong>totale fatturato</strong> rappresenta la somma di tutte le fatture emesse nell'anno selezionato,
      al netto delle eventuali note di credito registrate.
    </p>
    <p class="mb-0">
      Se la <strong>cassa previdenziale</strong> alla quale appartieni non è l'INPS (nel tuo caso è {{getFundName(organization_data?.favorite_pension_fund)}}), potresti vedere un valore diverso rispetto al totale delle fatture. Questo perchè la percentuale di Rivalsa o Cassa previdenziale, in questo caso, non produce reddito.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="izy-dialog-actions">
    <button
      matButton="filled"
      class="izy-button-primary custom-button-border"
      (click)="dialogRef.close()"
    >
      <mat-icon>check</mat-icon>
      Ok, capito
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Accordion dei mesi: ogni pannello e' una superficie bianca bordata nera con
     l'angolo basso-sinistra vivo, freccia di apertura nel tondo bianco bordato
     (come .izy-goto-arrow) e contatore eventi nella pillola bordata. -->
<div class="expansion-panels-container">
  <mat-accordion class="expansion-headers-align" multi>
    <mat-expansion-panel *ngFor="let month of months; let i = index"
                         [expanded]="isPanelExpanded(i)"
                         class="izy-month-panel izy-sharp-bl">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="izy-month-name">{{ month }}</span>
        </mat-panel-title>

        <mat-panel-description>
          <span class="izy-month-total">
            {{ getMonthTotal(i, selectedYear) | currency:'EUR' }}
          </span>
          <span class="izy-count-pill" *ngIf="getMonthEvents(i, selectedYear).length > 0">
            {{ getMonthEvents(i, selectedYear).length }}<span class="izy-count-pill-label">&nbsp;evento/i</span>
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div *ngIf="getMonthEvents(i, selectedYear).length > 0; else noEvents" class="izy-event-list">
        <!-- Card evento: parte alta bianca, footer con i comandi su fondo panna
             separato dal tratto nero 2px - stessa distinzione di superficie
             delle card documento e bozza. -->
        <div class="izy-event-card izy-sharp-bl custom-card-border"
             *ngFor="let event of getMonthEvents(i, selectedYear)">
          <div class="izy-event-body">
            <div class="izy-event-heading">
              <span class="izy-corner-icon">
                <mat-icon fontSet="material-icons-outlined">event</mat-icon>
              </span>
              <div class="izy-event-heading-text">
                <p class="izy-event-name mb-0">
                  <strong>{{ event.type }}</strong>: {{ event.name }}
                </p>
                <p class="izy-meta mb-0">
                  <mat-icon class="izy-meta-icon me-1" fontSet="material-icons-outlined">calendar_today</mat-icon>
                  <span class="izy-meta-label me-1">Scadenza:</span>
                  {{ event.date | date:'dd/MM/yyyy' }}
                </p>
              </div>
            </div>

            <p class="izy-meta mb-0 mt-1">
              <mat-icon class="izy-meta-icon me-1" fontSet="material-icons-outlined">euro</mat-icon>
              <span class="izy-meta-label me-1">Importo:</span>
              <strong [ngClass]="{'text-green': event.is_credit}">
                {{ event.is_credit ? '(' : '' }}{{ event.amount | currency:'EUR' }}{{ event.is_credit ? ')' : '' }}
              </strong>
            </p>
          </div>

          <div class="izy-event-footer">
            <!-- Stato di pagamento: resta a sinistra, i comandi a destra. -->
            <div
              *ngIf="event.is_credit === false"
              class="d-flex align-items-center me-auto izy-event-paid"
            >
              <mat-checkbox
                [(ngModel)]="event.is_paid"
                (change)="togglePaidStatus(event)"
                (click)="$event.stopPropagation()"
                class="me-1 custom-checkbox"
              >
              </mat-checkbox>
              <span class="text-small">{{event.is_paid ? 'Saldato' : 'Non saldato'}}</span>
            </div>

            <mat-chip *ngIf="event.is_created_by_user === true" class="status-chip me-2">
              Creato dall'utente
            </mat-chip>

            <button
              mat-stroked-button
              (click)="openEventeDetail(event)"
              class="me-2 izy-event-btn custom-button-border"
            >
              <mat-icon fontSet="material-icons-outlined">help</mat-icon>
              Dettagli
            </button>

            <button
              *ngIf="event.is_created_by_user === true"
              mat-stroked-button
              (click)="softDeleteEvent(event)"
              class="me-2 izy-event-btn izy-event-btn--warn custom-button-border"
            >
              <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
              Elimina
            </button>
          </div>
        </div>
      </div>

      <ng-template #noEvents>
        <p class="no-events-message">Nessun evento fiscale per questo mese</p>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="pt-3 mb-3"></div>
